<section>
  <form novalidate [formGroup]="formGroup">
    <div>
      <div class="row">
        <div class="col-md">
          <p-floatLabel>
            <input
              pInputText
              id="firstName"
              formControlName="firstName"
              type="text"
              class="w-100"
              [ngClass]="{
                'ng-invalid ng-dirty': showErrorMessage(formGroup, 'firstName')
              }"
              (change)="getQualityCounts()"
            />
            <label for="firstName">Your First Name</label>
          </p-floatLabel>
          <span
            *ngIf="showErrorMessage(formGroup, 'firstName')"
            class="error-message"
          >
            Please enter First Name
          </span>
        </div>
        <div class="col-md">
          <p-floatLabel>
            <input
              pInputText
              id="lastName"
              formControlName="lastName"
              type="text"
              class="w-100"
              [ngClass]="{
                'ng-invalid ng-dirty': showErrorMessage(formGroup, 'lastName')
              }"
              (change)="getQualityCounts()"
            />
            <label for="lastName">Your Last Name</label>
          </p-floatLabel>
          <span
            *ngIf="showErrorMessage(formGroup, 'lastName')"
            class="error-message"
          >
            Please enter Last Name
          </span>
        </div>
        <div class="col-md">
          <p-floatLabel>
            <p-calendar
              inputId="exhibitorDOB"
              formControlName="exhibitorDOB"
              placeholder="MM/DD/YYYY"
              maxlength="10"
              styleClass="w-100"
              [iconDisplay]="'input'"
              [showIcon]="true"
              [touchUI]="false"
              [minDate]="minDate"
              [maxDate]="maxDate"
              [defaultDate]="maxDate"
              [ngClass]="{
                'ng-invalid ng-dirty': showErrorMessage(
                  formGroup,
                  'exhibitorDOB'
                )
              }"
              (onSelect)="getQualityCounts()"
              (onBlur)="getQualityCounts()"
              (onInput)="onInput($event)"
            />
            <label for="exhibitorDOB">Date of Birth</label>
          </p-floatLabel>
          <span
            *ngIf="showErrorMessage(formGroup, 'exhibitorDOB')"
            class="error-message"
          >
            Please select Date of Birth
          </span>
        </div>
      </div>
    </div>
    <div
      *ngIf="
        registration.qualityCounts &&
        (!registration.ageDiscloserRequired ||
          (registration.ageDiscloserRequired &&
            registration.ageDiscloserAccepted))
      "
    >
      <div class="row">
        <div class="col-md">
          <div class="quality-counts">
            <span>Quality Counts - </span>
            <span>{{ registration.qualityCounts.qcNumber ?? "N/A" }}</span>
          </div>
        </div>
        <div class="col-md">
          <div class="quality-counts">
            <span>Grade - </span>
            <span>{{ registration.qualityCounts.currentGrade ?? "N/A" }}</span>
          </div>
        </div>
        <div class="col-md">
          <div class="quality-counts">
            <span>Level - </span>
            <span>{{ registration.qualityCounts.level ?? "N/A" }}</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md text-center">
          <span class="additional-info-msg">
            Please Enter Additional Information
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col-md">
          <p-floatLabel>
            <input
              pInputText
              id="address"
              formControlName="address"
              type="text"
              class="w-100"
              [ngClass]="{
                'ng-invalid ng-dirty': showErrorMessage(formGroup, 'address')
              }"
              (change)="getAddress()"
            />
            <label for="address">Mailing Address</label>
          </p-floatLabel>
          <span
            *ngIf="showErrorMessage(formGroup, 'address')"
            class="error-message"
          >
            Please enter Mailing Address
          </span>
        </div>
        <div class="col-md">
          <p-floatLabel>
            <input
              pInputText
              id="city"
              formControlName="city"
              type="text"
              class="w-100"
              [ngClass]="{
                'ng-invalid ng-dirty': showErrorMessage(formGroup, 'city')
              }"
              (change)="getAddress()"
            />
            <label for="city">City</label>
          </p-floatLabel>
          <span
            *ngIf="showErrorMessage(formGroup, 'city')"
            class="error-message"
          >
            Please enter City
          </span>
        </div>
        <div class="col-md">
          <p-floatLabel>
            <p-dropdown
              inputId="state"
              formControlName="state"
              optionLabel="name"
              optionValue="abbreviation"
              styleClass="w-100"
              [options]="states"
              [ngClass]="{
                'ng-invalid ng-dirty': showErrorMessage(formGroup, 'state')
              }"
              [panelStyle]="{
                position: 'absolute',
                bottom: '100%',
                transform: 'translateY(-5px)'
              }"
              (onChange)="getAddress()"
            />
            <label for="state">State</label>
          </p-floatLabel>
          <span
            *ngIf="showErrorMessage(formGroup, 'state')"
            class="error-message"
          >
            Please select State
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col-md">
          <p-floatLabel>
            <input
              pInputText
              id="zipCode"
              formControlName="zipCode"
              pKeyFilter="int"
              minlength="5"
              maxlength="5"
              type="text"
              class="w-100"
              [ngClass]="{
                'ng-invalid ng-dirty': showErrorMessage(formGroup, 'zipCode')
              }"
            />
            <label for="zipCode">Zip Code</label>
          </p-floatLabel>
          <span
            *ngIf="showErrorMessage(formGroup, 'zipCode')"
            class="error-message"
          >
            Please enter Zip Code
          </span>
        </div>
        <div class="col-md">
          <p-floatLabel>
            <input
              pInputText
              id="email"
              formControlName="email"
              type="text"
              class="w-100"
              [ngClass]="{
                'ng-invalid ng-dirty': showErrorMessage(formGroup, 'email')
              }"
            />
            <label for="email">Email</label>
          </p-floatLabel>
          <span
            *ngIf="showErrorMessage(formGroup, 'email')"
            class="error-message"
          >
            Please enter Email
          </span>
          <span
            *ngIf="showErrorMessage(formGroup, 'email', 'pattern')"
            class="error-message"
          >
            Please enter valid Email
          </span>
        </div>
        <div class="col-md">
          <p-floatLabel>
            <p-inputMask
              inputId="phone"
              formControlName="phone"
              mask="(999) 999-9999"
              slotChar="#"
              styleClass="w-100"
              [ngClass]="{
                'ng-invalid ng-dirty': showErrorMessage(formGroup, 'phone')
              }"
            />
            <label for="phone">Phone</label>
          </p-floatLabel>
          <span
            *ngIf="showErrorMessage(formGroup, 'phone')"
            class="error-message"
          >
            Please enter Phone
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col-md">
          <p-floatLabel>
            <p-dropdown
              inputId="county"
              formControlName="county"
              [options]="counties"
              [filter]="true"
              optionLabel="county"
              optionValue="county"
              styleClass="w-100"
              [ngClass]="{
                'ng-invalid ng-dirty': showErrorMessage(formGroup, 'county')
              }"
              [panelStyle]="{
                position: 'absolute',
                bottom: '100%',
                transform: 'translateY(-5px)'
              }"
              (onChange)="onCountyChange($event)"
            />
            <label for="county">County</label>
          </p-floatLabel>
          <span
            *ngIf="showErrorMessage(formGroup, 'county')"
            class="error-message"
          >
            Please select County
          </span>
        </div>
        <div class="col-md">
          <p-floatLabel>
            <p-dropdown
              inputId="chapter"
              formControlName="chapter"
              [options]="chapters"
              [filter]="true"
              optionLabel="chapter"
              optionValue="chapter"
              styleClass="w-100"
              [ngClass]="{
                'ng-invalid ng-dirty': showErrorMessage(formGroup, 'chapter')
              }"
              [panelStyle]="{
                position: 'absolute',
                bottom: '100%',
                transform: 'translateY(-5px)'
              }"
            />
            <label for="chapter">Chapter</label>
          </p-floatLabel>
          <span
            *ngIf="showErrorMessage(formGroup, 'chapter')"
            class="error-message"
          >
            Please select Chapter
          </span>
        </div>
        <div class="col-md"></div>
      </div>
    </div>
  </form>
</section>
<p-dialog
  header="Quality Count Verification Failed"
  [(visible)]="showDialog"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [style]="{ width: '50%' }"
>
  <div class="d-flex">
    <div><i class="pi pi-exclamation-triangle"></i></div>
    <div>
      Your Quality Counts number cannot be verified. Please complete the course
      or contact your County Extension Agent or Agricultural Science Teacher for
      assistance.
    </div>
  </div>
  <div class="text-end mt-2">
    <p-button
      [rounded]="true"
      tabindex="-1"
      label="Continue"
      (onClick)="resetQualityCounts()"
    />
  </div>
</p-dialog>
